<template>
  <v-row class="mt-0">
    <v-col class="d-block" cols="12">
      <v-alert
        v-model="model"
        color="error lighten-1"
        class="py-3 px-1 mb-2 white--text"
      >
        <template v-slot:prepend>
          <v-icon size="24" class="mx-2 d-none d-sm-block white--text">mdi-alert</v-icon>
        </template>
        We do not have a valid payment method on file for your account.
        Please
        <router-link class="white--text fw-bold underline"
                     :to="{ name: 'profile_info' }"
        >
          update your payment method
        </router-link>.
        <template v-slot:append>
          <v-btn icon elevation="0" aria-label="Dismiss." @click="noticeDismiss" :disabled="loading">
            <v-icon class="white--text">mdi-close</v-icon>
          </v-btn>
        </template>
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import amapi from '@/api/amapi'

export default {
  name: 'HasNoCardAlert',
  data () {
    return {
      model: true,
      loading: false
    }
  },
  methods: {
    ...mapActions({
      getProfile: 'getProfile',
      reportError: 'reportError'
    }),
    async noticeDismiss () {
      this.loading = true
      try {
        await amapi.makecall('notice_dismiss', {
          type: 'nocard'
        })
        this.model = false
        this.getProfile()
      } catch (e) {
        this.reportError(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
